<template>
  <div id="xxx_main" :class="{ 'container-dark': theme_dark }">
    <div class="nav-top">
      <div class="nav-left">
        <img src="../../assets/img/返回箭头.png" class="nav-img" @click="back()" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">挣钱明细</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <div class="menu-block">
      <li v-for="(item, index) in arr" :key="index">
        <div class="ub ub-pc menu-item">
          <div class="ub width6 ub-pc" v-if="item.type == '增加'">
            <span class="item-integral add">+ {{ item.amount }}</span>
            <span class="ub ub-pe score-tag">积分</span>
          </div>
          <div class="ub width6 ub-pc" v-if="item.type == '减少'">
            <span class="item-integral reduce ub ub-pc">- {{ item.amount }}</span>
            <span class="ub ub-pe score-tag">积分</span>
          </div>
          <span class="ub ub-as ub-f1 item-name">{{ item.type_dtl }}</span>
          <div class="item-date ub ub-ver ub-pc">
            <span>{{ item.date }}</span>
            <span>{{ item.time }}</span>
          </div>
        </div>
        <div v-if="index < arr.length - 1" class="menu-line"></div>
      </li>

      <div class="ub ub-pc ub-ver no-data" v-if="arr.length <= 0">
        <img src="../../assets/img/暂无数据.png" class="no-data-img" />
        <div class="no-data-txt">暂无挣钱明细(ಥ_ಥ)</div>
        <div class="ub ub-ac ub-pc menu-money-btn" @click="goto_mkmny()">
          研究挣钱攻略>>
        </div>
      </div>
    </div>
    <div class="ub ub-pc ub-ac" v-if="arr.length > 0" >
      <div class="ub ub-ac ub-pc btn" @click="load_more()"><span>加载更多</span></div>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      arr: [],
      index: 0,
      size: 20,
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    goto_mkmny() {
      this.$router.push({ name: "mkmny" });
    },
    init_page() {
      this.load_more();
    },

    load_more() {
      this.$loading("加载...");

      var self = this;
      var uid = self.$store.state.uid;
      self.get({
        url:"/App/GetScoreData/?uid=" +uid +"&index=" +this.index +"&size=" +this.size,
        success: function (data_serve) {
          //console.log(JSON.stringify(data_serve));
          self.$loading.close();

          if (data_serve.length <= 0 && self.index > 0) {
            self.$toast.center("没有更多了~");
            return false;
          }

          // 处理每个数据对象，将日期和时间分开
          data_serve.forEach(function (item) {
            if (item.dtm) {
              var dtmParts = item.dtm.split(" ");
              item.date = dtmParts[0];
              item.time = dtmParts[1];
            }
          });

          self.arr = self.arr.concat(data_serve);
          self.index++;
        },
        error: function (err) {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-block {
  padding: 0.2rem 0.8rem;
  background-color: #fff;
  .menu-item {
    height: 3rem;
    justify-content: space-between;
    .item-integral {
      font-size: 1.5rem;
      display: inline-block;
      color: red;
    }
    .add {
      color: #04f82d;
    }
    .reduce {
      color: red;
    }
    .score-tag {
      display: inline-block;
      width: 3rem;
      font-size: 0.5rem;
      color: #afafaf;
      line-height: 1.8rem;
      margin-left: 0.5rem;
      line-height: 3.5rem;
    }
    .width6 {
      text-align: center;
    }
    .item-name {
      font-size: 0.5rem;
      color: #929292;
    }
    .item-date {
      span {
        font-size: 0.75rem;
      }
    }
    .item-date span:nth-child(2) {
      margin-top: 0.5rem;
    }
  }
}

.no-data {
  padding: 5rem 0;
  .no-data-img {
    width: 9rem;
    height: 9rem;
  }

  .no-data-txt {
    margin-top: 1rem;
    color: #afafaf;
    margin-left: 0.5rem;
  }
  .menu-money-btn {
    background-color: #e92162;
    width: 8rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: 0.3rem;
    color: #fff;
    font-size: 1rem;
    margin-top: 1.2rem;
  }
}

.btn {
  margin: 1rem 0;
  padding: 0.5rem 8rem;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  span {
    font-size: 0.9rem;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.menu-line {
  border-top: 1px solid #EFEFEF;
}

.container-dark {
  min-height: 100vh;
  background-color: #2F2E33;
  .menu-block {
    background-color: #2c2b30;
    .menu-item {
      .item-date {
        color: #FDFDFD;
      }
    }
  }
  .menu-line {
    border-top: 1px solid #404040;
  }
}
</style>